module.exports = __webpack_public_path__ + "assets/img/w_d_i_1.1a111ab7.jpg";